import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AbilityContext } from '../../../../components/Ability'
import NotFound from '../../../NotFound'
import ShopeeLogin from './Features/TiktokLogin'
import ShopeeOrderList from './Features/TiktokOrderList'
import TikTokLogin from './Features/TiktokLogin'
import TikTokOrderList from './Features/TiktokOrderList'


const TikTokPage = () => {
  const ability = useContext(AbilityContext)
  return (
    <Routes>
      <Route
        path="/login"
        element={
          ability.can('read', 'Users') ? <TikTokLogin /> : <NotFound />
        }
      />
      <Route
        path="/order"
        element={
          ability.can('read', 'Users') ? <TikTokOrderList /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default TikTokPage
